import {CSSProperties, ReactNode} from "react";
import {Container, Padding} from "@web-libs/ui/layout-components/container";
import {getCssVar} from "@web-libs/features/colors/application/colors";
import cssStyles from "./page-container.module.css";
import {mergeClassNames} from "@web-libs/util/class-names/class-names";

export type PageContainerProps = {
    children: ReactNode
    style?: CSSProperties
    padding?: Padding,
    fullscreen?: boolean,
    className?: string
}

export const PageContainer = ({ children, style, padding, fullscreen = false, className }: PageContainerProps) => {
    return (
        <Container className={mergeClassNames(className,cssStyles.pageContainer)} padding={padding} style={{
            minHeight: fullscreen ? "100%" : "auto",
            height: fullscreen ? "100%" : "auto",
            maxHeight: fullscreen ? "100%" : "auto",
            backgroundColor: getCssVar("lightShade"),
            boxSizing: "border-box",
            ...style
        }}>
            {children}
        </Container>
    )
}
